(function () {
  function setupPhoneToggle(section) {
    var checkbox = section.querySelector('[data-newsletter-sms-toggle]');
    var field = section.querySelector('[data-newsletter-phone-field]');
    if (!checkbox || !field) return;

    var input = field.querySelector('input');

    function sync() {
      field.classList.toggle('is-visible', checkbox.checked);
      if (!input) return;
      if (checkbox.checked) {
        input.name = 'contact[note][Phone]';
        input.setAttribute('required', '');
      } else {
        input.name = '';
        input.removeAttribute('required');
        input.value = '';
      }
    }

    checkbox.addEventListener('change', sync);
    sync();
  }

  function setupModal(section) {
    var modal = section.querySelector('[data-newsletter-modal]');
    if (!modal) return;

    function close() {
      modal.hidden = true;
      document.body.classList.remove('overflow-hidden-desktop');
    }

    function open() {
      modal.hidden = false;
      document.body.classList.add('overflow-hidden-desktop');
      var closeButton = modal.querySelector('[data-newsletter-modal-close]');
      if (closeButton) closeButton.focus();
    }

    modal.addEventListener('click', function (event) {
      if (event.target.closest('[data-newsletter-modal-close]') || event.target.hasAttribute('data-newsletter-modal-overlay')) {
        close();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) close();
    });

    if (section.querySelector('[data-newsletter-success]')) open();
  }

  function init() {
    document.querySelectorAll('[data-newsletter-section]').forEach(function (section) {
      setupPhoneToggle(section);
      setupModal(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
